import { io } from "socket.io-client";

const SOCKET_URL =
  import.meta.env.VITE_SOCKET_URL ||
  import.meta.env.VITE_APP_URL ||
  "https://production-vantage-ai-747039019468.asia-southeast1.run.app";

export const socket = io(SOCKET_URL, {
  // Attempt WebSocket first, fall back to polling.
  // This is REQUIRED for Cloud Run because it doesn't support raw WebSocket
  // upgrades on cold starts — polling allows the connection to establish
  // and then upgrade to WebSocket automatically.
  transports: ["websocket", "polling"],
  autoConnect: true,
  // Reconnect automatically with backoff
  reconnection: true,
  reconnectionAttempts: 10,
  reconnectionDelay: 1000,
  reconnectionDelayMax: 5000,
  // Timeout per connection attempt
  timeout: 20000,
});
